// extracted by mini-css-extract-plugin
export var deleteModal = "_fj-0";